import { render, staticRenderFns } from "./AssignmentAttempts.vue?vue&type=template&id=4dea2104&scoped=true&"
import script from "./AssignmentAttempts.vue?vue&type=script&lang=js&"
export * from "./AssignmentAttempts.vue?vue&type=script&lang=js&"
import style0 from "./AssignmentAttempts.vue?vue&type=style&index=0&id=4dea2104&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dea2104",
  null
  
)

export default component.exports